import { render, staticRenderFns } from "./CodePopup.vue?vue&type=template&id=c563980e&scoped=true&lang=pug"
import script from "./CodePopup.vue?vue&type=script&lang=ts"
export * from "./CodePopup.vue?vue&type=script&lang=ts"
import style0 from "./CodePopup.vue?vue&type=style&index=0&id=c563980e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563980e",
  null
  
)

/* custom blocks */
import block0 from "./Dialog.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FMyAccount%2Fcomponents%2FCodePopup.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports